import { useLocale } from "@/hooks/useLocale";

export function useLocaleDirection() {
    const locale = useLocale();
    return locale === "he" ? "rtl" : "ltr";
}
